import axios from "axios";
import { NOTIFICATIONS_URL } from "../utils";

export const fetchNotifications = async () => {
  return await axios.get(NOTIFICATIONS_URL);
};
